import { render, staticRenderFns } from "./MobileModule.vue?vue&type=template&id=549afad2&"
import script from "./MobileModule.vue?vue&type=script&lang=js&"
export * from "./MobileModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MobileModule.vue"
export default component.exports